export default "__VITE_ASSET__f1c67494__"